import s from './style.css';

const Circle = ({
	size = 100,
	totalSliceWidth,
	percentage,
	fact,
	singleSliceWidth,
	color,
	num,
	percentageInline,
	onRight
}) => (
	<div
		className={s.dataPoint}
		style={{
			height: `${size}%`
		}}
	>
		<div className={s.flipper}>
			<div
				className={s.circleWrap}
				style={{
					transform: `rotate(${totalSliceWidth - 90}deg)`
				}}
			>
				<div
					className={s.circle}
					style={{
						transform: `translateZ(0)  rotate(${90 - totalSliceWidth}deg)`,
						width: `${size}%`
					}}
				>
					{percentageInline && (
						<div
							className={s.percentage}
							style={{
								transform: `rotate(${totalSliceWidth / 2}deg) rotateY(-${
									onRight ? 180 : 0
								}deg)`
							}}
						>
							<span className={s.percentageText}>{percentage}%</span>
						</div>
					)}
					<div
						className={s.circleInner}
						style={{
							background: color,
							transform: `rotate(${singleSliceWidth * num}deg)`
						}}
					/>
				</div>
			</div>
		</div>

		{fact && (
			<div
				className={s.fact}
				style={{
					transitionDuration: `${0.2 * num + 0.2}s`
				}}
			>
				{percentage}% {fact}
			</div>
		)}
	</div>
);

export default Circle;



// WEBPACK FOOTER //
// ./components/SliceChart/Circle.js